import { useEffect, useRef, useState } from 'react';
import authApi from '../api/auth';

export default function useRegistrationOtp(email) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    const [sentTo, setSentTo] = useState('');
    const [code, setCode] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [retryAt, setRetryAt] = useState(0);
    const [now, setNow] = useState(Date.now());
    const pending = useRef(false);
    const currentEmail = useRef(normalizedEmail);
    currentEmail.current = normalizedEmail;
    const sent = Boolean(sentTo && sentTo === normalizedEmail);
    const seconds = Math.max(0, Math.ceil((retryAt - now) / 1000));

    useEffect(() => {
        setCode(''); setError(''); setMessage(''); setSentTo('');
    }, [normalizedEmail]);
    useEffect(() => {
        if (!retryAt) return undefined;
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, [retryAt]);

    const send = async () => {
        if (pending.current || seconds > 0) return;
        pending.current = true; setBusy(true); setError('');
        const target = normalizedEmail;
        try {
            const result = await authApi.sendRegistrationOtp(target);
            setRetryAt(Date.now() + (result.retryAfter || 60) * 1000);
            setNow(Date.now());
            if (currentEmail.current === target) {
                setSentTo(target); setCode(''); setMessage(result.message);
            }
        } catch (err) {
            setError(typeof err === 'string' ? err : 'Unable to send verification code. Please try again.');
        } finally { pending.current = false; setBusy(false); }
    };
    const submit = async (values, register) => {
        if (pending.current) return;
        if (!sent) { await send(); return; }
        if (!/^\d{6}$/.test(code)) { setError('Enter the six-digit code from your email.'); return; }
        pending.current = true; setBusy(true); setError('');
        try { return await register({ ...values, email: normalizedEmail, emailOtp: code }); }
        finally { pending.current = false; setBusy(false); }
    };
    return { sent, code, setCode, busy, message, error, seconds, send, submit };
}
